import FallbackUI from './ErrorFallbackUI';

export default FallbackUI;
